import { useModal } from '@ebay/nice-modal-react'
import { useMatch } from '@tanstack/router'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'

import LoadingModal from '../../components/common/loading-modal'
import { Layout } from '../../components/layouts'
import { Header } from '../../components/promotions'
import { useBoundStore } from '../../store/store'
import type { ApiResponse } from '../../types/api'
import { api } from '../../utils/api-client'
import closeModal from '../../utils/closeModal'

interface Promo {
  title: string
  content: string
  meta_title: string
  meta_description: string
}

const PromoTermsAndConditions = () => {
  const id = useMatch({ from: '/promotions/$promoId' }).params.promoId
  const username = useBoundStore(state => state.user.username)
  const [promo, setPromo] = useState<Promo | null>(null)
  const loadingModal = useModal(LoadingModal)

  useEffect(() => {
    const getPromo = async () => {
      if (!id) return

      try {
        loadingModal.show()
        const response = await api.get<ApiResponse<Promo>>('/ajax_check.php', {
          type: 'get_promotion_content_v2',
          pro_id: id.split('-')[0],
          username,
        })
        const { status, info } = response.data
        if (status === 1) {
          setPromo(info)
        }
      } catch (error) {
        console.error(error)
      } finally {
        closeModal(loadingModal)
      }
    }
    getPromo()
  }, [])

  if (!promo) return null

  return (
    <Layout>
      <Helmet>
        {promo.meta_title && <title>{promo.meta_title}</title>}
        {promo.meta_description && (
          <meta name="description" content={promo.meta_description} />
        )}
      </Helmet>
      <Header />
      <div
        className=" bg-primary text-txt w-full pt-2.5 pb-[50px] px-[15px] xl:px-[90px] xl:py-[50px] 3xl:px-[150px] 3xl:py-[50px] 4xl:px-[250px] 4xl:py-[50px] [&>*]:font-normal [&>a]:text-highlight"
        dangerouslySetInnerHTML={{ __html: promo.content }}
      />
    </Layout>
  )
}

export default PromoTermsAndConditions
